import { Spinner } from '@frontend/components/common';
import { FormattedMessage } from 'react-intl';

import { DefaultContainer } from '../../../modal/detail-modal/default-container/default-container';
import { useValidLicensesCard } from './valid-licenses-card.controller';

export interface ValidLicensesCardProps {
    userId: string;
}

export const ValidLicensesCard = (props: ValidLicensesCardProps) => {
    const viewProps = useValidLicensesCard(props);
    return (
        <DefaultContainer
            title={
                <FormattedMessage
                    id='profile.valid-licenses.title'
                    defaultMessage='Valid licenses'
                    description='Title for valid licenses card'
                />
            }
            content={
                viewProps.isLoading ? (
                    <Spinner />
                ) : (
                    <div className='inline-flex flex-col items-start justify-start gap-2 self-stretch'>
                        {viewProps.apps.length > 0 ? (
                            viewProps.apps.map((app) => (
                                <div
                                    key={app}
                                    className='text-foreground-default justify-start text-base font-medium'>
                                    {app}
                                </div>
                            ))
                        ) : (
                            <div className='text-brand-muted justify-start text-base font-medium'>
                                <FormattedMessage
                                    id='profile.valid-licenses.no-licenses'
                                    defaultMessage='No valid licenses'
                                    description='Message when user has no valid licenses'
                                />
                            </div>
                        )}
                    </div>
                )
            }
        />
    );
};
